<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="improvedSurvey.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="improvedSurvey"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="投诉日期">
              <el-date-picker
                  v-model="improvedSurvey.complaintDate"
                  disabled
                  type="date"
                  placeholder="选择日期"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="序列号">
              <el-input v-model="improvedSurvey.serialNo" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发生阶段">
              <el-select v-model="improvedSurvey.stage" placeholder="请选择发生阶段">
                <el-option
                    v-for="item in constant.toSelect(constant.stage)"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="improvedSurvey.customerName" placeholder="请输入" clearable>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    style="margin-left: 2%;"
                    @click="$refs.selectCustomer.open()">
                  选择
                </el-button>
              </el-input>
              <customer-select ref="selectCustomer" @select="selectCustomer"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出厂编号">
              <el-input v-model="improvedSurvey.factoryNo" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="反馈人员">
              <el-input v-model="improvedSurvey.creatorName" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="联系方式">
              <el-input v-model="improvedSurvey.contact" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="问题描述">
          <el-input v-model="improvedSurvey.problemDesc" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
          <div slot="toolbar">
            <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectMaterial.open()">
              新建
            </el-button>
          </div>
          <el-table
              :data="improvedSurvey.materialList">
            <el-table-column prop="materialNo" align="center" label="物料编号"/>
            <el-table-column prop="materialName" align="center" label="物料名称"/>
            <el-table-column prop="quantity" align="center" label="数量">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.quantity" :precision="2" :step="0.1"/>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="备注">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea"/>
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                class-name="vm-table_operate"
                width="140px">
              <template slot-scope="scope">
                <el-button type="danger" @click="oneDelete(scope.$index,scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <material-select ref="selectMaterial" @select="getDetails"/>
        </div>
        <div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
          <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
            <el-upload
                :action="actionUrl"
                :on-success="handleSuccess"
                :on-remove="handleRemove"
                :on-error="handlerError"
                :file-list="files"
                :show-file-list="false">
              <el-button size="small" type="primary" style="margin: 0 5px 0 0">添加附件</el-button>
            </el-upload>
          </div>
          <el-table
              v-if="improvedSurvey.attachments"
              ref="payData1"
              :data="improvedSurvey.attachments">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="fileName" align="center" label="附件描述">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
              <template slot-scope="scope">
                <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import constant from "@/util/constant";
  import auth from "@/util/loginUtil";
  import MaterialSelect from "@/views/information/SupplierManage/MaterialSelect";

  export default {
    name: "ImprovedSurveyEdit",
    components: {MaterialSelect, CustomerSelect},
    data() {
      return {
        constant,
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        files: [],
        improvedSurvey: {
          pkid: "",
          complaintDate: new Date(),
          billNo: "",
          serialNo: "",
          stage: "",
          complaintNature: "",
          materialNo: "",
          quantity: "",
          factoryNo: "",
          customerName: "",
          customerId: "",
          creatorName: auth.getName(),
          contact: "",
          problemDesc: "",
          attachments: [],
          materialList: [],
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        console.log(row);
        this.improvedSurvey.pkid = row.pkid;
        this.dialogVisible = true;
        if (this.improvedSurvey.pkid > 0) {
          this.getData();
        }
      },
      getDetails(row) {
        this.improvedSurvey.materialList.push({
          pkid: 0,
          masterId: 0,
          materialId: row.id,
          materialName: row.name,
          materialNo: row.no,
          quantity: 1,
          note: "",
        });
      },
      getData() {
        this.$http
          .get("basic", `improvedSurveys/${this.improvedSurvey.pkid}`)
          .then(resp => {
            this.improvedSurvey = resp;
          });
      },
      selectCustomer(row) {
        console.log(row);
        this.improvedSurvey.customerName = row.customerName;
        this.improvedSurvey.customerId = row.customerID;
      },
      fileDelete(row,index) {
        console.log(row);
        this.improvedSurvey.attachments.splice(index,1);
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      //物料表页面删除
      oneDelete(row, index) {
        this.improvedSurvey.materialList.splice(index, 1);
      },
      handleSuccess(response, file, fileList) {
        file.path = response;
        this.files = fileList;
        let object ={
          fileName:file.path.originalName,
          filePath:file.path.fullPath,
        };
        this.improvedSurvey.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if (this.improvedSurvey.pkid > 0) {
              this.$http
                .put("basic", "improvedSurveys/saveVo", this.improvedSurvey)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.improvedSurvey.complaintDate = null;
              this.$http
                .post("basic", "improvedSurveys", this.improvedSurvey)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
